/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_IntroInputs */

const en_directory_agent_readiness_intro = /** @type {(inputs: Directory_Agent_Readiness_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How well an agent can understand this product and reconstruct a documented workflow from its official information.`)
};

const zh_directory_agent_readiness_intro = /** @type {(inputs: Directory_Agent_Readiness_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评估 Agent 能否通过产品的官方信息理解产品，并重建一条有文档依据的工作流程。`)
};

/**
* | output |
* | --- |
* | "How well an agent can understand this product and reconstruct a documented workflow from its official information." |
*
* @param {Directory_Agent_Readiness_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_intro = /** @type {((inputs?: Directory_Agent_Readiness_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_intro(inputs)
	return zh_directory_agent_readiness_intro(inputs)
});
export { directory_agent_readiness_intro as "directory.agent_readiness.intro" }